(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[204],{

/***/ 32311:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chapterlist/[bookId]",
      function () {
        return __webpack_require__(39380);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _bookId_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Helmet.tsx + 1 modules
var Helmet = __webpack_require__(30258);
// EXTERNAL MODULE: ./src/components/Layout/Header/index.tsx
var Header = __webpack_require__(68307);
// EXTERNAL MODULE: ./src/components/Layout/ResponsiveWrap/index.tsx
var ResponsiveWrap = __webpack_require__(18648);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/REST.ts + 1 modules
var utils_REST = __webpack_require__(25108);
;// CONCATENATED MODULE: ./src/pages/ChapterList/action.ts

async function action_getChapterList(query, context) {
    return await REST.read({
        url: "/go/pcm/chapter/get-chapter-list",
        data: query,
        ctx: context
    });
}

;// CONCATENATED MODULE: ./src/pages/ChapterList/interfaces.ts
var interfaces_EncryptTypeEnum;
(function(EncryptTypeEnum) {
    EncryptTypeEnum[EncryptTypeEnum["NORMAL"] = 0] = "NORMAL";
    EncryptTypeEnum[EncryptTypeEnum["FOCK_ENCRYPT"] = 1] = "FOCK_ENCRYPT";
    EncryptTypeEnum[EncryptTypeEnum["FONT_ENCRYPT"] = 2] = "FONT_ENCRYPT";
    EncryptTypeEnum[EncryptTypeEnum["FOCK_FONT_ENCRYPT"] = 3] = "FOCK_FONT_ENCRYPT";
})(interfaces_EncryptTypeEnum || (interfaces_EncryptTypeEnum = {}));

// EXTERNAL MODULE: ./src/read-ui/Book/index.tsx + 1 modules
var Book = __webpack_require__(92740);
// EXTERNAL MODULE: ./src/utils/URL.ts
var URL = __webpack_require__(41688);
// EXTERNAL MODULE: ./src/read-ui/Cover/index.tsx + 1 modules
var Cover = __webpack_require__(35393);
// EXTERNAL MODULE: ./src/interface/IBook.ts
var IBook = __webpack_require__(79611);
// EXTERNAL MODULE: ./src/pages/ChapterList/utils.ts
var utils = __webpack_require__(20894);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/native-url/index.js
var native_url = __webpack_require__(11987);
// EXTERNAL MODULE: ./src/pages/ChapterList/components/ChapterItems/index.tsx + 1 modules
var ChapterItems = __webpack_require__(87310);
;// CONCATENATED MODULE: ./src/pages/ChapterList/index.tsx














const getServerSideProps = async (context)=>{
    context.res.setHeader("Cache-Control", "public, s-maxage=10, stale-while-revalidate=59");
    const bookId = decodeChapterListUrl(context.resolvedUrl);
    if (!bookId) {
        throw new Error("[error]Path is not valid: ".concat(context.resolvedUrl));
    }
    try {
        const { data  } = await getChapterList({
            bookId,
            encryptType: EncryptTypeEnum.NORMAL
        }, context);
        if (!data.content || data.content.bookInfo.checkLevel == 8 || data.content.bookInfo.checkLevel == 9) {
            return {
                notFound: true
            };
        }
        const correctUrl = chapterListUrl({
            bookId,
            bookName: data.content.bookInfo.bookName,
            novelType: BookTypeEnum.Novel
        });
        const { pathname , search  } = nodeUrl.parse(context.resolvedUrl);
        const isPureId = isPureIdChapterListUrl(pathname);
        if (pathname !== correctUrl && !isPureId) {
            // 非纯数字id的章节列表页才会重定向
            console.log("[redirect]Path is not valid: ", context.resolvedUrl);
            return {
                redirect: {
                    destination: "".concat(correctUrl).concat(search || ""),
                    statusCode: 301
                }
            };
        }
        return {
            props: {
                data: data.content,
                isPureId
            }
        };
    } catch (e) {
        console.log("[error]", e.toString());
        return {
            redirect: {
                destination: "/",
                statusCode: 301
            }
        };
    }
};
function ChapterListPage(param) {
    let { data , isPureId  } = param;
    const { bookInfo , volumeItems , lastChapterItem , curReadChapter  } = data;
    const { bookName ="" , bookId  } = bookInfo;
    const { title , description , keywords  } = (0,utils/* getTDK */.n)(bookName, bookInfo.description || "");
    const coverUrl = (0,URL/* bookcover */.oq)(bookInfo.bookId, null, bookInfo.coverId);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Helmet/* default */.Z, {
                title: title,
                keywords: keywords,
                description: description,
                bodyClassName: "bc_default"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "dn",
                children: "Table of ".concat(bookName)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResponsiveWrap/* default */.Z, {
                className: "pt16 pl16 pr16",
                maxWidth: 932,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Book/* default */.Z, {
                        leftPart: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cover/* default */.Z, {
                            src: coverUrl,
                            width: 52
                        }),
                        title: bookName,
                        subtitle: "".concat(bookInfo.authorName, " \xb7 ").concat(bookInfo.categoryName),
                        className: "pt12 pb12 pl12 pr12 br16 bc_fff",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "pa w100% h100% t0 l0",
                            href: (0,URL/* composeChapterUrl */.Wo)({
                                bookId: bookInfo.bookId,
                                bookName,
                                novelType: IBook/* BookTypeEnum.Novel */.Qt.Novel,
                                isPureId
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "dn",
                                children: bookName
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChapterItems/* default */.Z, {
                        ...data,
                        isPureId: isPureId
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/chapterlist/[bookId].tsx

var __N_SSP = true;
/* harmony default export */ var _bookId_ = (ChapterListPage);


/***/ }),

/***/ 68307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _read_ui_util_type__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44024);
/* harmony import */ var _read_ui_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65378);
/* harmony import */ var _read_ui_InputBox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68840);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_appManager__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3786);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53474);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _IntersectionObserver__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3075);
/* harmony import */ var _QDReport__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73393);












const HeaderLogoSize = (0,_read_ui_util_type__WEBPACK_IMPORTED_MODULE_9__/* .tuple */ .b)("small", "auto");
const Header = (param)=>{
    let { isFixed =true , children , className ="" , logoSize ="auto" , search  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const handleClick = async ()=>{
        (0,_utils_appManager__WEBPACK_IMPORTED_MODULE_6__/* .openApp */ .CB)({
            router,
            afQuery: {
                af_adset: _utils_appManager__WEBPACK_IMPORTED_MODULE_6__/* .AF_ADSET.header_download */ .en.header_download
            }
        });
    };
    const downloadReport = {
        uiname: "topdownload",
        dl: 1
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
                className: "w100% df h48 bc_fff aic jcc ".concat((_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().header), " ").concat(isFixed ? "pf t0 l0" : "pr", " ").concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "g_wrap df aic w100% ".concat((_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().headerInner)),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/?refer=header",
                            rel: "nofollow",
                            className: "w32 h32 dib mr16 ".concat((_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().logo), " _").concat(logoSize),
                            title: "Webnovel",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "dn",
                                children: "Chereads"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "f1 mr16",
                            children: search && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_read_ui_InputBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                className: "ff_sans fs14 fw400",
                                size: "sm",
                                placeholder: "Search"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_IntersectionObserver__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            Component: _read_ui_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                            size: "xs",
                            onClick: handleClick,
                            report: downloadReport,
                            ...(0,_QDReport__WEBPACK_IMPORTED_MODULE_8__/* .toDomProps */ .Qy)(downloadReport),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "ff_sans fs12 lh16 fw700 ls1",
                                children: "DOWNLOAD APP"
                            })
                        })
                    ]
                })
            }),
            isFixed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "db h48"
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(Header));


/***/ }),

/***/ 87310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ChapterItems; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/read-ui/IconButton/index.ts + 2 modules
var IconButton = __webpack_require__(84006);
// EXTERNAL MODULE: ./src/read-ui/Icon/index.tsx + 1 modules
var Icon = __webpack_require__(7249);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/URL.ts
var URL = __webpack_require__(41688);
// EXTERNAL MODULE: ./src/pages/ChapterList/components/ChapterItem/styles.module.scss
var styles_module = __webpack_require__(11484);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/@webnovel/chereads-icons/dist/react-icon.esm.js
var react_icon_esm = __webpack_require__(80717);
// EXTERNAL MODULE: ./src/interface/IBook.ts
var IBook = __webpack_require__(79611);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/pages/ChapterList/components/ChapterItem/index.tsx








const PIN_ELEMENT = "crt_reading_cha";
const ChapterItem = (param)=>{
    let { chapterInfo , bookId , bookName , isCurrent =false , novelType =IBook/* BookTypeEnum.Novel */.Qt.Novel , isPureId =false  } = param;
    const { chapterIndex , chapterName , chapterId , publishTimeFormat  } = chapterInfo;
    let showIcon;
    if (chapterInfo.isVip === 1 && chapterInfo.isAuth !== 1) {
        showIcon = react_icon_esm/* GiftOutline */.O_;
    } else if (chapterInfo.isVip === 2 && chapterInfo.isAuth !== 1) {
        showIcon = react_icon_esm/* LockOutline */.nZ;
    } else {
        showIcon = null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        title: chapterName,
        href: (0,URL/* composeChapterUrl */.Wo)({
            bookId,
            chapterId,
            bookName,
            chapterIndex,
            novelType,
            isPureId
        }),
        className: "".concat(isCurrent ? "".concat(PIN_ELEMENT) : "", " g_hr lh24 db oh fs14 clearfix pt16 pb16 pr"),
        children: [
            +chapterIndex >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "fl ".concat((styles_module_default()).num, " mr4 c_l"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "".concat(isCurrent ? "c_primary" : ""),
                    children: chapterIndex
                })
            }),
            showIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                className: "fr ml8 mt4 c_s",
                Svg: showIcon,
                size: 16
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "oh",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        className: "ells _3 oh fs16 mb2 lh24 c_l ".concat(isCurrent ? "c_primary" : ""),
                        children: chapterName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                        className: "db fs12 lh16 ell c_s",
                        children: publishTimeFormat
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_ChapterItem = (/*#__PURE__*/(0,react.memo)(ChapterItem));

// EXTERNAL MODULE: ./src/pages/ChapterList/utils.ts
var utils = __webpack_require__(20894);
// EXTERNAL MODULE: ./src/utils/adaptor.ts
var adaptor = __webpack_require__(80002);
// EXTERNAL MODULE: ./src/pages/ChapterList/components/ChapterItems/index.module.scss
var index_module = __webpack_require__(97551);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/pages/ChapterList/components/ChapterItems/index.tsx










const DATA_LIST_ITEM = "volumeName";
const ChapterItems = (props)=>{
    var ref;
    const { bookInfo , Component ="h1" , isPureId =false , volumeItems , lastChapterItem , curReadChapter , initVisibleCount =0 , realCount =0 , novelType =IBook/* BookTypeEnum.Novel */.Qt.Novel , className  } = props;
    const { bookId ="" , bookName =""  } = bookInfo;
    const [isRevert, setIsRevert] = (0,react.useState)(false);
    const listRef = (0,react.useRef)(null);
    var ref1;
    const [showMoreBtn, setShowMoreBtn] = (0,react.useState)(Boolean(initVisibleCount) && Math.min((ref1 = volumeItems === null || volumeItems === void 0 ? void 0 : (ref = volumeItems.reduce) === null || ref === void 0 ? void 0 : ref.call(volumeItems, (a1, b1)=>a1 + b1.chapterItems.length, 0)) !== null && ref1 !== void 0 ? ref1 : 0, realCount || Number.MAX_SAFE_INTEGER) > initVisibleCount);
    (0,react.useEffect)(()=>{
        if (listRef.current && initVisibleCount) {
            // 找到第 visibleCount 个章节的dom，获取它的offsetTop，设置为整个列表的高度
            const listChildren = listRef.current.children;
            let count = 0;
            for(let i = 0; i < listChildren.length; i++){
                const child = listChildren[i];
                if (child.getAttribute("data-list-item") !== DATA_LIST_ITEM) {
                    count += 1;
                }
                if (count > initVisibleCount) {
                    listRef.current.style.maxHeight = "".concat((0,adaptor/* rem */.h)(child.offsetTop - 8), "rem");
                    break;
                }
            }
        }
    }, [
        initVisibleCount
    ]);
    if (!(volumeItems === null || volumeItems === void 0 ? void 0 : volumeItems.length)) {
        return null;
    }
    const { list  } = (0,utils/* generateList */.D)({
        volumeItems,
        bookInfo,
        curReadChapter,
        revert: isRevert
    });
    const handleRenderContent = ()=>{
        let count = 0;
        const renderContent = (item)=>{
            if (realCount > 0 && count >= realCount) {
                return null;
            }
            const isCurrent = "chapterId" in item && (item === null || item === void 0 ? void 0 : item.chapterId) === curReadChapter;
            if (!item) {
                return null;
            }
            let content = null;
            if ("isVolume" in item && (item === null || item === void 0 ? void 0 : item.isVolume)) {
                content = /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                    className: "mt16 fs14 c_m lh20",
                    "data-list-item": DATA_LIST_ITEM,
                    children: [
                        "Volume ",
                        item.volumeId,
                        " ",
                        item.volumeName ? ":".concat(item.volumeName) : ""
                    ]
                }, item.volumeId);
            }
            // if ("isPrivilegeCard" in item && item?.isPrivilegeCard) {
            //   content = <PrivilegeCard key={index} dark={dark} />;
            // }
            if ("chapterId" in item && item.chapterId) {
                count += 1;
                content = /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ChapterItem, {
                        chapterInfo: item,
                        isCurrent: isCurrent,
                        bookId: bookId,
                        bookName: bookName,
                        isPureId: isPureId,
                        novelType: novelType
                    }, item.chapterId)
                }, item.chapterId);
            }
            return content;
        };
        return list === null || list === void 0 ? void 0 : list.map((item)=>renderContent(item));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb16 mt16 pr df aic jcc mr-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                        className: "t_h6 c_l f1",
                        children: "Table of contents"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        ghost: true,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            Svg: react_icon_esm/* SortOutline */.pF,
                            size: 20
                        }),
                        onClick: ()=>setIsRevert((pre)=>!pre)
                    })
                ]
            }),
            lastChapterItem && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        className: "fs14 lh20 c_m",
                        children: "Latest Update"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ChapterItem, {
                        chapterInfo: lastChapterItem,
                        bookId: bookId,
                        bookName: bookName,
                        isPureId: isPureId
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                ref: listRef,
                className: (index_module_default()).list,
                children: handleRenderContent()
            }),
            showMoreBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                // href={chapterListUrl({
                //   novelType,
                //   bookId,
                // })}
                onClick: ()=>setShowMoreBtn(true),
                className: (index_module_default()).moreBtn,
                children: "VIEW MORE"
            })
        ]
    });
};
/* harmony default export */ var components_ChapterItems = (ChapterItems);


/***/ }),

/***/ 20894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ generateList; },
/* harmony export */   "n": function() { return /* binding */ getTDK; }
/* harmony export */ });
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__);

const _reverse = (list)=>[
        ...list
    ].reverse();
/**
 * 章节列表 => 渲染列表
 * @param data
 * @param revert
 * @param currentChapter
 * @returns {Array}
 */ const generateList = (param)=>{
    let { volumeItems , bookInfo , curReadChapter , revert  } = param;
    const list = [];
    if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(volumeItems)) {
        return {
            list
        };
    }
    (revert ? _reverse(volumeItems) : volumeItems).forEach((param)=>{
        let { volumeId , volumeName , chapterItems  } = param;
        const newChapterItems = chapterItems.filter(// noArchive = 1 代表是来自于 Google robot 的回源
        (item)=>{
            return (item === null || item === void 0 ? void 0 : item.chapterLevel) == 0 || (item === null || item === void 0 ? void 0 : item.noArchive) === 1;
        });
        if (newChapterItems.length > 0) {
            if (volumeId) {
                list.push({
                    isVolume: true,
                    volumeId,
                    volumeName
                });
            }
            (revert ? _reverse(newChapterItems) : newChapterItems).forEach((chapterItem)=>{
                list.push({
                    ...chapterItem
                });
            });
        }
    });
    // 如果有特权提示，则加上特权提示
    // const { hasPrivilege } = bookInfo;
    // if (hasPrivilege === 1) {
    //   if (revert) {
    //     list.unshift({ isPrivilegeCard: true });
    //   } else {
    //     list.push({ isPrivilegeCard: true });
    //   }
    // }
    let curCatalogIndex = 0;
    if (curReadChapter) {
        curCatalogIndex = list.findIndex((chapter)=>"chapterId" in chapter && chapter.chapterId === curReadChapter);
    }
    return {
        list,
        curCatalogIndex
    };
};
const getTDK = (bookName, desc)=>{
    return {
        title: "".concat(bookName, " Novel Read Free"),
        keywords: "".concat(bookName, ", novel, read novel, free novel"),
        description: "Read ".concat(bookName, " light novel. ").concat(desc.replace(/[\r]?\n/g, "").slice(0, 250), "...")
    };
};


/***/ }),

/***/ 92740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ read_ui_Book; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/read-ui/Book/book.tsx


const Book = (param)=>{
    let { leftPart , overlineText , overlineTextColor , title , subtitle , footer , rightPart , className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(className, " pr df aic"),
        children: [
            leftPart,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ml12 f1 df fdc jcc",
                children: [
                    !!overlineText && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "t_overline c_primary df",
                        style: {
                            color: overlineTextColor
                        },
                        children: [
                            '"',
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "ell",
                                children: overlineText
                            }),
                            '"'
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        className: "t_title_s c_l ell mt2",
                        children: title
                    }),
                    typeof subtitle === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "t_body_s c_m ell mt2",
                        children: subtitle
                    }) : subtitle,
                    footer
                ]
            }),
            rightPart,
            children
        ]
    });
};
/* harmony default export */ var book = (/*#__PURE__*/(0,react.memo)(Book));

;// CONCATENATED MODULE: ./src/read-ui/Book/index.tsx


/* harmony default export */ var read_ui_Book = (book);


/***/ }),

/***/ 32508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ai": function() { return /* binding */ CoveringCorner; },
/* harmony export */   "em": function() { return /* binding */ CoveringBottom; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39349);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const Cover = (param)=>{
    let { className ="" , width =52 , height , auto =false , children , src , alt ="" , imgClassName ="" , ...otherProps } = param;
    const _height = height || width * 3 / 2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: "".concat(className, " ").concat((_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().bookCover), " pr br4 dib vam bc_default bsbb"),
        style: auto ? {
            width: "100%",
            height: "100%"
        } : {
            width: "".concat(width / 16, "rem"),
            height: "".concat(_height / 16, "rem")
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pa t0 l0 br2 w100% h100% ".concat(imgClassName),
                style: {
                    width: width,
                    height: _height,
                    background: "url(".concat(src, ") center/auto 100% no-repeat border-box border-box")
                },
                ...otherProps
            }),
            children
        ]
    });
};
const CoveringCorner = (param)=>{
    let { className ="" , backgroundColor , position , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "".concat(className, " ").concat((_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cornerBadge), " pa _").concat(position, " df aic jcc t_label_l"),
        style: {
            backgroundColor
        },
        children: children
    });
};
const CoveringBottom = (param)=>{
    let { backgroundColor , color , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "".concat((_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().bottomPart), " pa b0 l0 r0 w100% t_label_m ell tac pl8 pr8"),
        style: {
            backgroundColor,
            color
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(Cover));


/***/ }),

/***/ 35393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* reexport */ CornerPos; },
  "Z": function() { return /* binding */ Cover; }
});

// EXTERNAL MODULE: ./src/read-ui/Cover/cover.tsx
var cover = __webpack_require__(32508);
;// CONCATENATED MODULE: ./src/read-ui/Cover/interfaces.ts
var CornerPos;
(function(CornerPos) {
    CornerPos["leftTop"] = "leftTop";
    CornerPos["rightTop"] = "rightTop";
    CornerPos["leftBottom"] = "leftBottom";
    CornerPos["rightBottom"] = "rightBottom";
})(CornerPos || (CornerPos = {}));

;// CONCATENATED MODULE: ./src/read-ui/Cover/index.tsx


/* harmony default export */ var Cover = (cover/* default */.ZP);


/***/ }),

/***/ 80002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ rem; }
/* harmony export */ });
// TODO: 16 得有个统一配置的地方
const rem = (px)=>px / 16;


/***/ }),

/***/ 53474:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__ziRJg","headerInner":"styles_headerInner__JAhR6","logo":"styles_logo__W4LZ7"};

/***/ }),

/***/ 11484:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"num":"styles_num___sIei"};

/***/ }),

/***/ 97551:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"ChapterItems_list__kW9Em","moreBtn":"ChapterItems_moreBtn__ZpKFP"};

/***/ }),

/***/ 39349:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bookCover":"style_bookCover__EKwKC","cornerBadge":"style_cornerBadge__PfuC8","bottomPart":"style_bottomPart__dH9vV"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [885,672,774,888,179], function() { return __webpack_exec__(32311); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);